import React from 'react';
import { ProductFruits as ProductFruitsImpl } from 'react-product-fruits';
import { useProductFruits } from './useProductFruits';

/**
 * `ProductFruits` wrapping component
 *
 * @returns {JSX.Element | null} The rendered ProductFruits component or null if loading.
 */
export function ProductFruits() {
  const { loading, user } = useProductFruits();

  if (loading) {
    return null;
  }

  return <>{user && <ProductFruitsImpl language="en" user={user} workspaceCode="lYUHfRAZHb9ACJE4" />}</>;
}
